import React, { useState, useEffect } from 'react';
import { Eye, Star, Heart } from 'lucide-react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { useNavigate } from 'react-router-dom';
import { useAlert } from '../Context/AlertContext';
import { useRating } from '../Context/RatingContext';


export default function VideoCard({ video, category, layout = "card" }) {
    const navigate = useNavigate();
    const [size, setSize] = useState(20);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const [favorites, setFavorites] = useState(JSON.parse(localStorage.getItem("av_favorites")) || []);
    const [isFavorite, setIsFavorite] = useState(false);
    const { showAlert } = useAlert();

    const { openRatingModal } = useRating(); // Access the rating modal function


    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };
        window.addEventListener('resize', handleResize);
        setSize(isMobile ? 15 : 20); // Adjust size dynamically for mobile
        return () => window.removeEventListener('resize', handleResize);
    }, [isMobile]);

    // Check if the video is in favorites when the component mounts or when favorites update
    useEffect(() => {
        setIsFavorite(favorites.some((fav) => fav.ID === video.ID));
    }, [favorites, video.ID]);

    function goToVideo() {
        navigate("/singlevideo", { state: { video, category } });
    }

    const addToFavorites = (video) => {
        const storedFavorites = JSON.parse(localStorage.getItem("av_favorites")) || [];
        const isAlreadyFavorite = storedFavorites.some((fav) => fav.ID === video.ID);
    
        const updatedFavorites = isAlreadyFavorite
            ? storedFavorites.filter((fav) => fav.ID !== video.ID) // Remove video if already a favorite
            : [...storedFavorites, video]; // Add video if not in favorites
    
        setFavorites(updatedFavorites);
        localStorage.setItem("av_favorites", JSON.stringify(updatedFavorites));
    
        showAlert(isAlreadyFavorite ? "❌ Video removed from favorites!" : "✅ Video added to favorites!", 
                  isAlreadyFavorite ? "danger" : "success");
    };

    return (
        <div
            data-aos='zoom-in'
            className={`videoCard ${layout === "list" ? "list-layout" : "card-layout"}`}
        >
            {/* Thumbnail */}
            <LazyLoadImage
                src={video.Thumbnail}
                alt={video.Title}
                className='thumbnail'
                onClick={goToVideo}
            />

            {/* Video Info */}
            <div className="video-info">
                <h6 className="video-title">{video.Title}</h6>

                <div className="video-stats">
                    <p className='eye-icon'>
                        <Eye size={size} /> {video.PlayCount}
                    </p>

                    <div className='rating-icons'>
                        <p className='star-icon'  onClick={() => openRatingModal(video.ID)}>
                            <Star size={size} /> {video.avrate}
                        </p>
                        <p className='heart-icon' onClick={() => addToFavorites(video)}>
                            <Heart size={size} color={isFavorite ? "red" : "white"} />
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}
